import { render, staticRenderFns } from "./DossierEditQuickCopyReady.vue?vue&type=template&id=8cd9815c&"
import script from "./DossierEditQuickCopyReady.vue?vue&type=script&lang=ts&"
export * from "./DossierEditQuickCopyReady.vue?vue&type=script&lang=ts&"
import style0 from "./DossierEditQuickCopyReady.vue?vue&type=style&index=0&id=8cd9815c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd9815c')) {
      api.createRecord('8cd9815c', component.options)
    } else {
      api.reload('8cd9815c', component.options)
    }
    module.hot.accept("./DossierEditQuickCopyReady.vue?vue&type=template&id=8cd9815c&", function () {
      api.rerender('8cd9815c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditQuickCopyReady.vue"
export default component.exports